<template>
  <div id="app">
    <Header />
    <About />
    <Footer />
  </div>
</template>

<script>
// require("typeface-raleway");

//import components
import Header from "./components/Header.vue";
import About from "./components/About.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "app",
  metaInfo: {
    title: "Jeanna Chambers",
    titleTemplate: "%s | Newborn Photography",
  },
  components: {
    Header,
    About,
    Footer,
  },
};
</script>
